export const STATISTICS_NAV_SECTIONS = [
  { key: "orders", path: "/main/statistics/orders" },
  { key: "products", path: "/main/statistics/products" },
  { key: "commissions", path: "/main/statistics/commissions" },
  { key: "transfers", path: "/main/statistics/transfers" },
];

export function canViewStatisticsOrders(context) {
  return context.isProductEnabled();
}

export function canViewStatisticsProducts(context) {
  return context.isProductEnabled();
}

export function canViewStatisticsCommissions(context) {
  return context.shopHasAgents();
}

export function canViewStatisticsTransfers(context) {
  return context.isNewWechatTransferEnabled();
}

const SECTION_ACCESS = {
  orders: canViewStatisticsOrders,
  products: canViewStatisticsProducts,
  commissions: canViewStatisticsCommissions,
  transfers: canViewStatisticsTransfers,
};

export function getVisibleStatisticsSections(context) {
  return STATISTICS_NAV_SECTIONS.filter((section) => {
    const check = SECTION_ACCESS[section.key];
    return check ? check(context) : false;
  });
}

export function buildStatisticsPermissionContext({
  isProductEnabled,
  shopHasAgents,
  isNewWechatTransferEnabled,
}) {
  return {
    isProductEnabled,
    shopHasAgents,
    isNewWechatTransferEnabled,
  };
}

export function hasStatisticsSubRoutePermission(pathname, context) {
  if (!pathname || pathname.indexOf("/statistics/") === -1) {
    return true;
  }

  if (pathname.indexOf("/statistics/overview") !== -1) {
    return true;
  }
  if (pathname.indexOf("/statistics/orders") !== -1) {
    return canViewStatisticsOrders(context);
  }
  if (pathname.indexOf("/statistics/products") !== -1) {
    return canViewStatisticsProducts(context);
  }
  if (pathname.indexOf("/statistics/commissions") !== -1) {
    return canViewStatisticsCommissions(context);
  }
  if (pathname.indexOf("/statistics/transfers") !== -1) {
    return canViewStatisticsTransfers(context);
  }

  return true;
}
